import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20media%20collage%20with%20Japanese%20and%20Korean%20film%20elements%2C%20cinematic%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20abstract%20geometric%20shapes%2C%20soft%20bokeh%20lights%2C%20elegant%20minimal%20composition%2C%20dark%20and%20warm%20color%20palette%2C%20artistic%20style%20with%20film%20grain%20texture&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
        alt="aaa一级日韩 - 日韩影视娱乐资讯"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide leading-tight">
          探索日韩娱乐的
          <span className="block mt-2 text-primary-300">无限精彩</span>
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-2xl mb-8 leading-relaxed">
          最新日剧韩剧推荐 · K-POP与J-POP音乐动态 · 日本韩国电影资讯 · 综艺节目与明星追踪
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/japan-drama"
            className="px-8 py-3 rounded-md bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览日剧推荐
          </Link>
          <Link
            to="/category/kpop"
            className="px-8 py-3 rounded-md bg-white/15 backdrop-blur-sm text-white font-medium text-sm hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-white/20"
          >
            K-POP动态
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-8 text-white/60 text-xs">
          <div className="flex items-center gap-1.5">
            <i className="ri-article-line text-sm"></i>
            <span>每日更新</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-group-line text-sm"></i>
            <span>十万+读者</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-tv-line text-sm"></i>
            <span>千部资源</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 rounded-full border-2 border-white/40 flex items-start justify-center">
          <span className="block w-1 h-2 bg-white/60 rounded-full mt-2 animate-bounce"></span>
        </div>
      </div>
    </section>
  );
}